import React from 'react';
import { Banner } from 'containers/tinting/banner/components';
import { StepsContainer } from 'containers/tinting/steps/components/steps-container';
import { OptionsContainer } from 'containers/tinting/options/components/options-container';
import { QuestionsContainer } from 'containers/tinting/questions/components/questions-container';
import { useTintingPage } from './hooks';

export const TintingPage = () => {
	useTintingPage();

	return (
		<div className="services-landings__content">
			<Banner />
			<StepsContainer />
			<OptionsContainer />
			<QuestionsContainer />
		</div>
	);
};
